import { cloneDeep, intersection } from 'lodash';

import type { Category, Item, Pagination } from '../../../models';
import type { SortSettings } from '../../../models/SortSettings';
import { sortAssets } from './sortAssets';

export interface CommonModel {
  selectedCategories: Array<string>;
  selectedTags: Array<string>;
}
export class EditMultipleForm {
  assets: Array<Item> = [];
  lastSortSettings: SortSettings;
  pagination: Pagination;
  mode: string; // mode is 'edit', 'delete', or 'edit-access-sharing'

  initialCommonModel: CommonModel = {
    selectedCategories: [],
    selectedTags: [],
  };

  currentCommonModel: CommonModel = {
    selectedCategories: [],
    selectedTags: [],
  };

  isSaving: boolean = false;
  hasSaved: boolean = false;

  static create(
    assets: Array<Item>,
    initialSortSettings: SortSettings,
    mode: string,
    clearSelection: boolean = true
  ): EditMultipleForm {
    const form = new EditMultipleForm();
    const clonedAssets = cloneDeep(assets);
    form.assets = sortAssets(clonedAssets, initialSortSettings);
    form.lastSortSettings = initialSortSettings;
    form.pagination = {
      sortBy: initialSortSettings.sortBy,
      descending: initialSortSettings.descending,
      rowsPerPage: 100,
      page: 1,
      totalItems: 0,
      pages: 1,
    };
    form.mode = mode; // 'edit', 'delete', or 'edit-access-sharing'

    // these assets originally come from an array that another <fuel-table> is operating on, and <fuel-table> stores selection state directly
    //   in the row objects themselves (row.isSelected)...in this context with isSelectable=false the behavior <fuel-table> has is to
    //   display "selected" rows with a green highlight effect...there's no selection to be done here so make sure we get rid of this...
    if (clearSelection) {
      for (const asset of form.assets) {
        asset.isSelected = false;
        asset.isDone = false;
        asset.hasWarning = false;
      }
    }

    if (mode === 'edit') {
      const categoriesForEachAsset = form.assets.map((asset) => {
        const categories = asset.categories as Array<Category>;
        return categories.map((c) => c.id);
      });

      const tagsForEachAsset = form.assets.map((asset) => {
        return asset.tags;
      });
      // console.log('categoriesForEachAsset', categoriesForEachAsset)
      // console.log('categoriesForEachAsset', intersection(...categoriesForEachAsset))
      form.initialCommonModel = {
        selectedCategories: intersection(...categoriesForEachAsset),
        selectedTags: intersection(...tagsForEachAsset),
      };
    } else {
      form.initialCommonModel = {
        selectedCategories: [],
        selectedTags: [],
      };
    }
    form.currentCommonModel = cloneDeep(form.initialCommonModel);
    return form;
  }
}
